import React from "react";

function ContactIcons(){
    return(
        <div className="col-sm-7">
                    <a className="btn-social-icon btn p-3" href="https://github.com/kunal-1308">
                    <span className="fa-brands fa-github"></span>
                    </a>
                    <a className="btn-social-icon btn p-3" href="https://twitter.com/KunalBhapkar1">
                    <span className="fa-brands fa-twitter"></span>
                    </a>
                    <a className="btn-social-icon btn p-3" href="https://www.facebook.com/kunal.bhapkar">
                    <span className="fa-brands fa-facebook"></span>
                    </a>
                    <a className="btn-social-icon btn p-3" href="https://www.linkedin.com/in/kunal-bhapkar/">
                    <span className="fa-brands fa-linkedin"></span>
                    </a>
        </div>
    );
}

export default ContactIcons;